import { createSlice, createAsyncThunk } from '@reduxjs/toolkit';
import axios from 'axios';
import { API_BASE_URL, getAuthHeader } from '../../../services/api';

// Public: fetch posts
export const fetchPosts = createAsyncThunk('blog/fetchPosts', async (lang, thunkAPI) => {
  const res = await axios.get(`${API_BASE_URL}/blog?lang=${lang}`);
  return res.data;
});

export const fetchPostBySlug = createAsyncThunk('blog/fetchPost', async ({ slug, lang }) => {
  const res = await axios.get(`${API_BASE_URL}/blog/${slug}?lang=${lang}`);
  return res.data;
});

// Admin: CRUD
export const createPostAdmin = createAsyncThunk('blog/create', async (data, thunkAPI) => {
  const res = await axios.post(`${API_BASE_URL}/blog`, data, { headers: getAuthHeader() });
  return res.data;
});

export const updatePostAdmin = createAsyncThunk('blog/update', async ({ id, data }) => {
  const res = await axios.put(`${API_BASE_URL}/blog/${id}`, data, { headers: getAuthHeader() });
  return res.data;
});

export const deletePostAdmin = createAsyncThunk('blog/delete', async (id) => {
  await axios.delete(`${API_BASE_URL}/blog/${id}`, { headers: getAuthHeader() });
  return id;
});

export const fetchAllPostsAdmin = createAsyncThunk('blog/fetchAllAdmin', async (_, thunkAPI) => {
  const res = await axios.get(`${API_BASE_URL}/blog/admin/all`, { headers: getAuthHeader() });
  return res.data;
});

const blogSlice = createSlice({
  name: 'blog',
  initialState: { posts: [], currentPost: null, isLoading: false, error: null },
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(fetchPosts.pending, (state) => { state.isLoading = true; })
      .addCase(fetchPosts.fulfilled, (state, action) => { state.isLoading = false; state.posts = action.payload; })
      .addCase(fetchPosts.rejected, (state, action) => { state.isLoading = false; state.error = action.payload; })
      .addCase(fetchPostBySlug.pending, (state) => { state.isLoading = true; })
      .addCase(fetchPostBySlug.fulfilled, (state, action) => { state.isLoading = false; state.currentPost = action.payload; })
      .addCase(fetchPostBySlug.rejected, (state, action) => { state.isLoading = false; state.error = action.payload; })
      .addCase(fetchAllPostsAdmin.fulfilled, (state, action) => {
        state.isLoading = false;
        state.adminPosts = action.payload;
      })
      .addCase(fetchAllPostsAdmin.rejected, (state, action) => {
        state.isLoading = false;
        state.error = action.payload;
      })
      // ... other cases for create, update, delete (update adminPosts accordingly)
      .addCase(createPostAdmin.fulfilled, (state, action) => {
        state.adminPosts.unshift(action.payload);
      })
      .addCase(updatePostAdmin.fulfilled, (state, action) => {
        const index = state.adminPosts.findIndex(p => p._id === action.payload._id);
        if (index !== -1) state.adminPosts[index] = action.payload;
      })
      .addCase(deletePostAdmin.fulfilled, (state, action) => {
        state.adminPosts = state.adminPosts.filter(p => p._id !== action.payload);
      })
  },
});

export default blogSlice.reducer;